import { Validator } from '@vista-digital/validator';
import { seatLayoutGridUnitValidator } from './seat-layout-grid-unit';
export const screenBoundaryValidator = Validator.object({
    left: seatLayoutGridUnitValidator,
    right: seatLayoutGridUnitValidator
});
